export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5803.3b7e44c7.jpg";